import { useEffect } from 'react';
import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';

const WebVitalsTracker = () => {
  useEffect(() => {
    const sendToAnalytics = (metric) => {
      // Send to Google Analytics if available
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', metric.name, {
          event_category: 'Web Vitals',
          value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
          event_label: metric.id,
          non_interaction: true,
        });
      }
      
      // Log for debugging
      console.log('Web Vital:', {
        name: metric.name,
        value: metric.value,
        id: metric.id,
        rating: metric.rating
      });
    };

    // Track all Core Web Vitals (using the new API)
    onCLS(sendToAnalytics);
    onINP(sendToAnalytics); // INP replaces FID in newer versions
    onLCP(sendToAnalytics);
    onFCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
  }, []);

  return null; // This component doesn't render anything
};

export default WebVitalsTracker;